module.exports = __webpack_public_path__ + "img/bg04.6ab86a24.jpg";